import React from 'react';
import DateTimePicker from 'react-datetime-picker';
import ReactDatePicker from 'react-date-picker';
import { View, Text, Image } from 'react-native';

import DateUtils from './date_time_utils';
import OPComponent from './op_component';
import I18n from '../../I18n';

import ValidatedComponent from './form/validated_comp';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

class DatePicker extends OPComponent {
  constructor(props) {
    super(props);

    // TODO: pull this from a shared prop from native?
    this.minuteInterval = 5;

    this.state = {
      calendarOpen: false,
      clockOpen: false,
      active: false,
    };

    this._validatedRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { calendarOpen, clockOpen } = this.state;
    // check that clock/calendar state changed
    if (calendarOpen !== prevState.calendarOpen || clockOpen !== prevState.clockOpen) {
      if (calendarOpen || clockOpen) {
        this.onFocus();
      }

      if (!calendarOpen && !clockOpen) {
        this.onBlur();
      }
    }
  }

  onFocus = () => {
    this.setState({ active: true });
    this.props.onFocus?.();
  };

  onBlur = () => {
    this.setState({ active: false });
    if (!!this.minuteInterval) {
      let date = new Date(this.props.selectedDate);
      DateUtils.roundMinutes(date, this.minuteInterval);
      this._onChange(date);
    }
    this.props.onBlur?.();
  };

  _onChange = (_newDate) => {
    if (_newDate === null && this.props.clearable) {
      this.props.onDate?.(null);
      return;
    }

    let newDate = _newDate || this.props.selectedDate;
    if (newDate && new Date(newDate).getTime() !== 0) this.props.onDate?.(newDate);
  };

  validate() {
    return this._validatedRef.current?.validate();
  }

  _onCalendarClose = () => {
    this.setState({ calendarOpen: false });
  };
  _onCalendarOpen = () => {
    this.setState({ calendarOpen: true });
  };
  _onClockClose = () => {
    this.setState({ clockOpen: false });
  };
  _onClockOpen = () => {
    this.setState({ clockOpen: true });
  };

  render() {
    const { props } = this;
    let { disabled, readOnly } = props;
    readOnly = !!readOnly;
    disabled = !!disabled;

    const mode = props.mode || 'date';
    const showTime = mode === 'datetime' || mode === 'time';
    const DateMaybeTimePicker = showTime ? DateTimePicker : ReactDatePicker;

    const classNames = props.fixedPos !== false ? 'react-date-picker-fixed-pos ' : '';
    const selectedDate = DateUtils.sanitizeDate(this.props.selectedDate);
    const showClearIcon = props.clearable && !!selectedDate;

    return (
      <ValidatedComponent
        ref={this._validatedRef}
        {...this.props}
        style={[{ zIndex: this.state.active ? 1000 : 0 }, props.containerStyle]}
        value={this.props.selectedDate}
        readOnly={readOnly}
      >
        <View style={{ marginBottom: 10, marginTop: 12, zIndex: 100 }}>
          {!!readOnly ? (
            <View style={{ borderBottomWidth: 1, borderBottomColor: COLOR.text }}>
              <Text style={[THEME.textRegular, { paddingBottom: 5, height: 30 }]}>
                {DateUtils.formatDateString(selectedDate)}
              </Text>
            </View>
          ) : (
            <DateMaybeTimePicker
              style={this.props.style}
              disabled={!!this.props.disabled}
              value={selectedDate}
              maxDate={this.props.maxDate}
              minDate={this.props.minDate}
              format={this.props.format}
              onFocus={this.onFocus}
              onCalendarClose={this._onCalendarClose}
              onCalendarOpen={this._onCalendarOpen}
              onClockClose={this._onClockClose}
              onClockOpen={this._onClockOpen}
              onChange={this._onChange}
              autoFocus={!!this.props.pickerOpen}
              isOpen={!!this.props.pickerOpen}
              clearIcon={showClearIcon ? undefined : null}
              calendarIcon={
                props.calendarIcon || (
                  <Image source={require('../../../resources/nav-icon-calendar.png')} />
                )
              }
              className={classNames + (props.className || 'react-date-picker-part-a')}
            />
          )}
        </View>
      </ValidatedComponent>
    );
  }
}

export default DatePicker;
